<template>
    <div class="method-container">
        <el-row :gutter="20">
            <el-col :span="4">
                <div class="left-box">
                    <p class="title">目录</p>
                    <ul>
                        <li v-for="item in menuList" :key="item.manualCategoryId" @click="getMethodDataByCategory(item)" :class="{'active': item.checked}">{{item.manualCategoryName}}</li>
                    </ul>
                    <div class="img-box">
                        <img :src="img" alt="">
                    </div>
                </div>
            </el-col>
            <el-col :span="20">
                <div class="right-box">
                    <el-table :data="methodData" :border="true">
                        <el-table-column label="序号" type="index" align="center" width="100px"></el-table-column>
                        <el-table-column label="分类" prop="rulePunishType" align="center">
                            <template slot-scope="scope">
                                <span v-if="scope.row.rulePunishType == 'Warning'">警告</span>
                                <span v-if="scope.row.rulePunishType == 'ViolationPenalty'">薪资奖惩</span>
                                <span v-if="scope.row.rulePunishType == 'StopApplication'">限制领取任务</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="规则说明" prop="ruleDescription" align="left" width="500">
                            <template slot-scope="scope">
                                <div v-html="scope.row.ruleDescription"></div>
                            </template>
                        </el-table-column>
                        <el-table-column label="处理力度" prop="rulePunishValue" align="center">
                            <template slot-scope="scope">
                                <span v-if="scope.row.rulePunishType == 'StopApplication' && scope.row.rulePunishValue">{{scope.row.rulePunishValue}}天</span>
                                <span v-if="scope.row.rulePunishType == 'ViolationPenalty' && scope.row.rulePunishValue">{{scope.row.rulePunishValue}}元</span>
                                <span v-if="scope.row.rulePunishType == 'Warning'">{{scope.row.ruleNoticeMessage}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="行为处理" prop="ruleHandle"></el-table-column>
                    </el-table>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import remind from './../assets/images/img_index_remind.png'
export default {
    data(){
        return{
            methodData: [],
            menuList: [],
            searchData: {
                pageSize: 100,
                pageNum: 1,
                manualCategoryId: '',
                isSystemRule: ''
            },
            img: remind
        }
    },
    mounted(){
        this.getMenuList();
        this.getMethodData();
    },
    methods: {
        getMenuList() {
            this.$http.post(API_ROOT.method + '/manualRule/queryCategory').then(response => {
                let result = response.data;
                if(result.success){
                    this.menuList = result.data;
                }else{
                    alert(result.msg)
                }
            }, err => {
                alert('网络繁忙，请稍后重试！')
            });
        },
        getMethodData(id) {
            this.searchData.manualCategoryId = id;
            this.$http.post(API_ROOT.method + '/manualRule/queryRule', this.searchData).then(response => {
                let result = response.data;
                if(result.success){
                    this.methodData = result.data.list;
                }else{
                    alert(result.msg);
                }
            }, err => {
                alert('网络繁忙，请稍后重试！')
            })
        },
        getMethodDataByCategory(row){
            this.menuList.map(item => {
                this.$set(item, 'checked', false);
                // item.checked = false;
            });
            this.$set(row, 'checked', true);
            this.getMethodData(row.manualCategoryId);
        }
    }
}
</script>

<style lang="less">
    .method-container{
        background: #e7f0f6;
        padding: 20px;
        height: 100%;
        overflow-y: scroll;
        .left-box{
            background: #fff;
            padding: 20px;
            li{
                margin-top: 20px;
                font-size: 14px;
                color: #333;
                cursor: pointer;
                &.active{
                    color: #4297ff;
                }
            }
            .img-box{
                width: 15.2%;
                position: fixed;
                bottom: 20px;
                left: 20px;
                img{
                    max-width: 100%;
                }
            }
        }
        .right-box{
            background: #fff;
            padding: 20px;
        }
        .title{
            padding-left: 8px;
            font-size: 18px;
            font-weight: bold;
            border-left: 3px solid #333;
            color: #333;
        }
        .el-table{
            td{
                div{
                    white-space: pre-wrap;
                }
            }
            .cell{
                img {
                    max-height: 80px !important;
                    width: auto !important;
                    max-width: 95% !important;
                }
            }
        }
    }
    
</style>



// WEBPACK FOOTER //
// ./src/page/taojinMethod.vue